import { useSelector } from "react-redux";
import { AppStore, SessionStore } from "../../types/store";

export function usePermissions() {
  const permissions = useSelector(
    (state: { app: AppStore }) => state.app.privateSettings?.permissions ?? []
  );
  const isAdministrator = useSelector(
    (state: { session: SessionStore }) => state.session.isAdministrator
  );

  const hasPermission = (permission: string | undefined): boolean => {
    if (!permission) return true;
    if (isAdministrator) return true;
    return permissions.includes(permission);
  };

  return { hasPermission };
}